'use client';

import { useState } from 'react';
import { useIsHydrated } from '@/hooks/useIsHydrated';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar = ({ onSearch }: SearchBarProps) => {
  const isHydrated = useIsHydrated();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  if (!isHydrated) {
    return (
      <div className="relative max-w-md">
        <input
          type="text"
          aria-label="Search insights"
          placeholder="Search insights..."
          className="w-full px-6 py-3 pl-12 bg-surface border border-border rounded-md font-body text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          disabled
        />
        <Icon
          name="MagnifyingGlassIcon"
          size={20}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
      </div>
    );
  }

  return (
    <form onSubmit={handleSearch} className="relative max-w-md">
      <input
        type="text"
        aria-label="Search insights"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search sustainability insights..."
        className="w-full px-6 py-3 pl-12 bg-surface border border-border rounded-md font-body text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary transition duration-300"
      />
      <Icon
        name="MagnifyingGlassIcon"
        size={20}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
      />
    </form>
  );
};

export default SearchBar;
